module.exports = __webpack_public_path__ + "img/i2.6ff524d1.png";